import { Env } from "./environment/environment.types";
import { readFromEnv } from "./environment/read-from-env";
export var targetActivities = {
    FRED: readFromEnv(Env.Fred),
    I_DONT_WANT_THIS_CAR: readFromEnv(Env.IDontWantThisCar),
    FOMO_EXPERIMENT_ID: readFromEnv(Env.FomoExperimentId),
    REQUEST_CALLBACK_EXPERIMENT_ID: readFromEnv(Env.RequestCallbackExperimentId)
};
